/**
 * Scatter cut filtering: show only points inside an active cut.
 */

export interface ScatterCutTimeRange {
  start_time?: string;
  end_time?: string;
  event_id?: number;
  type?: string;
}

export function filterScatterPointsByCutEvents<T extends { Datetime?: unknown }>(
  points: T[],
  cutRanges: ScatterCutTimeRange[]
): T[] {
  if (!cutRanges?.length) {return points;}

  return points.filter((d) => {
    const raw = d.Datetime;
    if (raw == null) {return false;}
    const dt = raw instanceof Date ? raw : new Date(String(raw));
    if (isNaN(dt.getTime())) {return false;}

    return cutRanges.some((range) => {
      if (typeof range === "number") {return false;}
      if (range.start_time && range.end_time) {
        const start = new Date(range.start_time);
        const end = new Date(range.end_time);
        return dt >= start && dt <= end;
      }
      return false;
    });
  });
}

export function filterScatterPointsByIds<T extends { ID?: unknown }>(
  points: T[],
  pointIds: Set<number>
): T[] {
  if (pointIds.size === 0) {return points;}
  return points.filter((d) => pointIds.has(Number(d.ID)));
}

export function collectDatetimeRangesFromPointIds(
  ids: Set<number>,
  charts: Array<{ series?: Array<{ originalData?: Array<{ ID?: unknown; Datetime?: unknown }>; data?: Array<{ ID?: unknown; Datetime?: unknown }> }> }>
): ScatterCutTimeRange[] {
  const ranges: ScatterCutTimeRange[] = [];
  for (const chart of charts) {
    for (const series of chart.series || []) {
      const points = series.originalData || series.data || [];
      for (const pt of points) {
        if (!ids.has(Number(pt.ID)) || pt.Datetime == null) {continue;}
        const dt = pt.Datetime instanceof Date ? pt.Datetime : new Date(String(pt.Datetime));
        if (isNaN(dt.getTime())) {continue;}
        const iso = dt.toISOString();
        ranges.push({ start_time: iso, end_time: iso, type: "event" });
      }
    }
  }
  return ranges;
}
